<form [formGroup]="audiomakerForm">
  @if (isLoaded) {
    <div class="top-margin">
      <div class="container">
        <div class="label">{{'AUDIOMAKERDLG.FILENAME' | translate}}</div>
        <input formControlName="filenameControl" value="{{filename}}" type="text"
          class="filename-input inputfield" id="filename-input"/>
        </div>
        <div class="container">
          <div class="label">{{'AUDIOMAKERDLG.LOCATION' | translate}}</div>
          <div class="is-vcentered left-dropdown inputfield">
            <div class="w2c-column inputfield-cloud">
              <div class="custom-select">
                <i class="fas fa-angle-down"></i>
                <label>
                  <select formControlName="locationControl">
                    <option [value]="locationArray[0]">{{'LOCATIONDROPDOWN.DEVICE' | translate}}</option>
                    <option [value]="locationArray[1]">{{'LOCATIONDROPDOWN.CLOUD' | translate}}</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </form>

  <div class="cb-container buttonContainer">
    <input type="button" class="cb-btn fa-pull-right" value="{{'AUDIOMAKERDLG.NO' | translate}}" (click)="no()"/>
    <input type="button" class="cb-btn fa-pull-right middle-cb-btn" value="{{'AUDIOMAKERDLG.CANCEL' | translate}}" (click)="deactivateAudiomaker();no()"/>
    <input type="button" class="cb-btn fa-pull-right" value="{{'AUDIOMAKERDLG.NEXT' | translate}}" (click)="ok();confirmLocation()"/>
  </div>